module.exports = __webpack_public_path__ + "media/images/room_monitor/wash_stop-a91bfea986c262f2a854c208528756e9.png";